import { useState, useCallback } from "react";
import { SystemBars } from "react-native-edge-to-edge";
import { useFocusEffect } from "@react-navigation/native";

type SystemBarsStyle = "light" | "dark" | "auto";

interface FocusedSystemBarsProps {
  /** Status bar style to apply when the screen is focused */
  style: SystemBarsStyle;
}

/**
 * SystemBars component that only renders when the screen is focused.
 * Automatically unmounts when the screen loses focus, allowing parent
 * SystemBars (e.g., from root layout) to take over.
 *
 * @example
 * ```tsx
 * <FocusedSystemBars style="light" />
 * ```
 */
export function FocusedSystemBars({ style }: FocusedSystemBarsProps) {
  const [isFocused, setIsFocused] = useState(false);

  useFocusEffect(
    useCallback(() => {
      setIsFocused(true);
      return () => {
        setIsFocused(false);
      };
    }, []),
  );

  if (!isFocused) {
    return null;
  }

  return <SystemBars style={style} />;
}
